module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "InboxContainer"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "Main"
    }
  }, [_c('div', {
    attrs: {
      "id": "EmailList"
    }
  }, [_vm._l((_vm.emails), function(email, index) {
    return _c('div', [(email.displayed) ? _c('div', {
      staticClass: "email-snippet",
      class: _vm.extraClasses(index),
      on: {
        "click": function($event) {
          return _vm.viewEmail(email, index)
        }
      }
    }, [_c('span', {
      staticClass: "received-label"
    }, [(email.isUnread) ? _c('i', {
      staticClass: "fa fa-circle",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e(), _vm._v("\n                        " + _vm._s(email.messageListDateString(_vm.displayStartDateTime)) + "\n                    ")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(email.from_firstname) + " " + _vm._s(email.from_surname) + " "), (email.hasAttachments) ? _c('i', {
      staticClass: "fa fa-paperclip"
    }) : _vm._e()]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(email.subject))]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(email.preview)
      }
    })]) : _vm._e()])
  }), _vm._v(" "), (_vm.inboxHasEmails === false) ? _c('p', {
    attrs: {
      "id": "NoEmailsText"
    }
  }, [_vm._v("No emails to display.")]) : _vm._e()], 2), _vm._v(" "), (!_vm.viewingEmail) ? _c('p', {
    attrs: {
      "id": "ClickToViewEmailPrompt"
    }
  }, [_vm._v("Click on an email in the list to view it.")]) : _vm._e(), _vm._v(" "), (_vm.viewingEmail) ? _c('div', {
    attrs: {
      "id": "EmailView"
    }
  }, [_c('button', {
    staticClass: "btn btn-brand btn-sm",
    attrs: {
      "id": "BackButton"
    },
    on: {
      "click": function($event) {
        return _vm.stopViewingEmail()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                Go Back\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-brand btn-sm",
    attrs: {
      "id": "PrintButton"
    },
    on: {
      "click": function($event) {
        return _vm.print()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                Print\n            ")]), _vm._v(" "), _c('h2', {
    staticClass: "email-initials"
  }, [_vm._v(_vm._s(_vm.from_initials))]), _vm._v(" "), _c('div', {
    staticClass: "email-details"
  }, [_c('h3', [_vm._v(_vm._s(_vm.subject))]), _vm._v(" "), _c('div', {
    staticClass: "email-sender-name"
  }, [_vm._v(_vm._s(_vm.from_firstname) + " " + _vm._s(_vm.from_surname))]), _vm._v(" "), _c('div', {
    staticClass: "email-date-time"
  }, [_vm._v(_vm._s(_vm.email_datetime_string))]), _vm._v(" "), _c('div', {
    staticClass: "email-recipient"
  }, [_vm._v("To: " + _vm._s(_vm.user.firstname) + " " + _vm._s(_vm.user.surname))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "email-body"
  }, [_c('div', {
    staticClass: "attachments"
  }, _vm._l((_vm.attachments), function(attachment) {
    return _c('div', [_c('a', {
      staticClass: "attachment-wrapper",
      attrs: {
        "href": '/inbox/download/' + attachment.md5,
        "download": ""
      }
    }, [_c('div', {
      staticClass: "attachment-link"
    }, [_c('i', {
      staticClass: "fa fa-file-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n                                " + _vm._s(attachment.filename) + "\n                            ")]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-paperclip",
      attrs: {
        "aria-hidden": "true"
      }
    })])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "email-content",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "FooterBar"
    }
  }, [_vm._v("Items: " + _vm._s(_vm.emailQueue.emailDisplayCount))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "TitleBar"
    }
  }, [_c('span', {
    attrs: {
      "id": "PageTitle"
    }
  }, [_vm._v("Inbox")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "TitleBarRightDiv"
    }
  }, [_c('img', {
    attrs: {
      "id": "TitleBarLogo",
      "src": "/images/logo-new.svg"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "fa fa-sign-out",
    attrs: {
      "href": "/logout"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "SideNavigation"
    }
  }, [_c('a', {
    staticClass: "nav-item active",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-inbox",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-item-label"
  }, [_vm._v("Inbox")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fc5f2e94","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./assets/vue/components/inbox.vue
// module id = 148
// module chunks = 0